namespace SolovisGateway.Admin.DataEnvironments {

    export interface CreateEnvironmentDatabaseDialogOptions {
        dataEnvironmentId: number;
        saveCallback: () => void;
    }


    /**
     * Show interface for creating the database for an environment.
     */
    export class CreateEnvironmentDatabaseDialog {

        private _dataEnvironmentId;
        private _saveCallback: () => void;

        private _dbServers: any[];      

        private _dbServerToElasticPoolNamesMap: any;
        private _dbServerToAsCopyOfSourceDbMap: any;

        private _formBuilder: Solovis.UI.InputControls.FormBuilder;
        private _dialog: Solovis.UI.Dialog;

        constructor(options: CreateEnvironmentDatabaseDialogOptions) {
            this._dataEnvironmentId = options.dataEnvironmentId;
            this._saveCallback = options.saveCallback;

            this._dbServerToElasticPoolNamesMap = [];
            this._dbServerToAsCopyOfSourceDbMap = [];  
        }

        public show() {
            let self = this;
            
            Solovis.Rpc.invokeAndWait(
                "~/Rpc/DbServers/GetDbServers",
                {},
                function (response, success) {
                    if (success) {                        
                        self._dbServers = response.result.dbServers ? response.result.dbServers : [];
                        self._internalShow();
                    }                   
                });
        }

        public _internalShow() {
            let self = this;

            let formBuilderDiv = $("<div>");
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv
            });

            // Server
            let dbServerOptions = [];
            if (self._dbServers.length) {
                $(self._dbServers).each(function (i, dbServer: any) {
                    dbServerOptions.push({
                        text: dbServer.server,
                        value: dbServer.server
                    });
                });
            }

            formBuilder.addEntry({
                name: "dbServer",
                label: "Database Server",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: dbServerOptions,
                        showClearButton: true,
                        searchEnabled: true
                    }
                }                
            });

            // Server
            formBuilder.addEntry({
                name: "asCopyOfDatabase",
                label: "As Copy Of Database",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        dataSource: this._createAsCopyOfDataSource(),
                        showClearButton: true,
                        searchEnabled: true
                    }
                },

                isVisible: function (formEntry) {                   
                    let dbServer = formEntry.formBuilder.getValueByName("dbServer");
                    let isSqlAzureServer = self._isSqlAzureServer(dbServer);

                    return dbServer && isSqlAzureServer;
                }
            });

            // Elastic Pool
            formBuilder.addEntry({
                name: "elasticPoolName",
                label: "Elastic Pool",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        dataSource: this._createElasticPoolDataSource(),
                        showClearButton: true,
                        searchEnabled: true
                    }
                },

                isVisible: function (formEntry) {                    
                    let dbServer = formEntry.formBuilder.getValueByName("dbServer");
                    let isSqlAzureServer = self._isSqlAzureServer(dbServer);

                    return dbServer && isSqlAzureServer;
                },

                postSetup: function (formEntry) {
                    let dbServerEntry = formEntry.formBuilder.getEntryByName("dbServer");
                    $(dbServerEntry).bind("valueChanged", function () {
                        formEntry.value(null);
                    });
                }
            });

            // Service Tier
            formBuilder.addEntry({
                name: "serviceTier",
                label: "Service Tier",

                initialValue: null,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: [
                            { text: "S0", value: "S0" },
                            { text: "S1", value: "S1" },
                            { text: "S2", value: "S2" },
                            { text: "S3", value: "S3" },
                            { text: "S4", value: "S4" },
                            { text: "S6", value: "S6" },
                            { text: "S7", value: "S7" },
                            { text: "S9", value: "S9" },
                            { text: "S12", value: "S12" },
                            { text: "P1", value: "P1" },
                            { text: "P2", value: "P2" },
                            { text: "P4", value: "P4" },
                            { text: "P6", value: "P6" },
                            { text: "P11", value: "P11" },
                            { text: "P15", value: "P15" },
                            { text: "PRS1", value: "PRS1" },
                            { text: "PRS2", value: "PRS2" },
                            { text: "PRS4", value: "PRS4" },
                            { text: "PRS6", value: "PRS6" },
                        ],
                        showClearButton: true
                    }
                },

                isVisible: function (formEntry) {                    
                    let dbServer = formEntry.formBuilder.getValueByName("dbServer");
                    let isSqlAzureServer = self._isSqlAzureServer(dbServer);
                    let elasticPoolName = formEntry.formBuilder.getValueByName("elasticPoolName");

                    return dbServer && isSqlAzureServer && !elasticPoolName;
                }
            });

            // Description
            formBuilder.addEntry({
                name: "newDatabaseName",
                label: "New Database Name (optional)",

                initialValue: null,

                editor: {
                    type: "text",
                    textOptions: {
                        maxLength: 255,
                        width: 300
                    }
                }
            });


            formBuilder.setupDone();

            this._formBuilder = formBuilder;

            this._dialog = formBuilder.showAsDialog({
                title: "Create Data Environment Database",
                desiredWidth: 600,
                desiredHeight: 600,

                showSaveCancel: true,
                saveButtonText: "Create",

                saveCallback: function () {
                    self._save();
                    return false;
                }
            });
        }



        private _isSqlAzureServer(dbServerName) {
            let dbServer = _.find(this._dbServers, function (i: any) { return i.server == dbServerName; });
            if (dbServer && dbServer.isSqlAzure) {
                return true;
            }

            return false;
        }

        private _createElasticPoolDataSource() {
            let self = this;

            let elasticPoolDataSource: Solovis.UI.InputControls.FormEditorSimpleDataSource = {
                load: function (loadOptions) {
                    let promise = new Promise(function (resolve, reject) {
                        let dbServer = self._formBuilder.getValueByName("dbServer");

                        let doLookup = function () {
                            let elasticPoolNames: string[] = self._dbServerToElasticPoolNamesMap[dbServer];

                            let results = [];

                            if (!_.isEmpty(elasticPoolNames)) {
                                for (let poolName of elasticPoolNames) {
                                    if (!loadOptions.searchValue || poolName.indexOf(loadOptions.searchValue) >= 0) {
                                        results.push({ text: poolName, value: poolName });
                                    }
                                }
                            }

                            resolve(results);
                        };

                        if (self._dbServerToElasticPoolNamesMap[dbServer]) {
                            doLookup();
                        }
                        else {
                            Solovis.Rpc.invoke(
                                "~/Rpc/DbServers/GetElasticPoolsForDbServer",
                                { server: dbServer },
                                function (response, success) {
                                    if (success) {
                                        let elasticPoolNames: string[] = response.result.elasticPoolNames;
                                        self._dbServerToElasticPoolNamesMap[dbServer] = elasticPoolNames;

                                        doLookup();
                                    }
                                    else {
                                        reject(response);
                                    }
                                });
                        }
                    });

                    return promise;
                },

                byKey: function (key) {
                    let promise = new Promise(function (resolve, reject) {
                        resolve({ text: key, value: key });
                    });

                    return promise;
                }
            };

            return elasticPoolDataSource;
        }


        private _createAsCopyOfDataSource() {
            let self = this;

            let asCopyOfDataSource: Solovis.UI.InputControls.FormEditorSimpleDataSource = {
                load: function (loadOptions) {
                    let promise = new Promise(function (resolve, reject) {
                        let dbServer = self._formBuilder.getValueByName("dbServer");

                        let doLookup = function () {
                            let sourceDbs: any[] = self._dbServerToAsCopyOfSourceDbMap[dbServer];

                            let results = [];

                            if (!_.isEmpty(sourceDbs)) {
                                for (let sourceDb of sourceDbs) {
                                    if (!loadOptions.searchValue || sourceDb.asCopyOfRef.indexOf(loadOptions.searchValue) >= 0) {
                                        results.push({ text: sourceDb.asCopyOfRef, value: sourceDb.asCopyOfRef });
                                    }
                                }
                            }

                            resolve(results);
                        };

                        if (self._dbServerToAsCopyOfSourceDbMap[dbServer]) {
                            doLookup();
                        }
                        else {
                            Solovis.Rpc.invoke(
                                "~/Rpc/DbServers/GetSourceDatabaseListForCopyToServer",
                                { targetServer: dbServer },
                                function (response, success) {
                                    if (success) {
                                        let sourceDatabases: string[] = response.result.sourceDatabases;
                                        self._dbServerToAsCopyOfSourceDbMap[dbServer] = sourceDatabases;

                                        doLookup();
                                    }
                                    else {
                                        reject(response);
                                    }
                                });
                        }
                    });

                    return promise;
                },

                byKey: function (key) {
                    let promise = new Promise(function (resolve, reject) {
                        resolve({ text: key, value: key });
                    });

                    return promise;
                }
            };

            return asCopyOfDataSource;
        }


        private _save() {
            let self = this;

            let dbServer = this._formBuilder.getValueByName("dbServer");
            let asCopyOfDatabase = this._formBuilder.getValueByName("asCopyOfDatabase");
            let elasticPoolName = this._formBuilder.getValueByName("elasticPoolName");
            let serviceTier = this._formBuilder.getValueByName("serviceTier");
            let newDatabaseName = this._formBuilder.getValueByName("newDatabaseName");

            let isAzure = dbServer ? this._isSqlAzureServer(dbServer) : false;

            var model = {
                dataEnvironmentId: this._dataEnvironmentId,         
                databaseServerName: dbServer ? dbServer : null,
                asCopyOfDatabase: (isAzure && asCopyOfDatabase) ? asCopyOfDatabase : null,
                elasticPoolName: (isAzure && elasticPoolName) ? elasticPoolName : null,
                serviceTier: (isAzure) ? serviceTier : null,
                newDatabaseName: newDatabaseName ? newDatabaseName : null
            };
            
            Solovis.Rpc.invokeAndWait(
                "~/Admin/DataEnvironmentAdmin/CreateDatabaseForDataEnvironment",
                {
                    model: model
                },
                function (response, success) {
                    if (success) {
                        var result = response.result;
                        if (result) {
                            if (result && result.modelResult && result.modelResult.databaseCreated) {
                                Solovis.UI.alert("Database created.");

                                self._dialog.close();

                                if (self._saveCallback) {
                                    self._saveCallback();
                                }
                            }
                            else {
                                if (response.result.errors) {
                                    self._formBuilder.applyErrors(response.result.errors);
                                }
                            }
                        }
                    }
                });
        }

    }

}